import { BreakpointValueProp } from "@toolkit/Framework/Common/Utilities/breakpointValues";
import getArray from "@toolkit/Framework/Common/Utilities/getArray";
import { TypeOfArray } from "@toolkit/Framework/Types/Common";

const getFullBreakpointValues = <T extends BreakpointValueProp<any>>(values: T, breakpointCount: number) => {
    const breakpointValues = getArray(values);

    if (!breakpointValues) {
        return breakpointValues;
    }

    let lastValue: any = null;
    const result: TypeOfArray<typeof breakpointValues>[] = [];

    for (let i = 0; i < breakpointCount; i++) {
        if (i < breakpointValues.length) {
            const value = breakpointValues[i];

            if (value !== null) {
                lastValue = value;
            }
        }

        result.push(lastValue);
    }

    return result;
};

export default getFullBreakpointValues;
